import type { TFunction } from "i18next";
import { ApiError } from "@/api/client";

/** 文档里 32314 复用了两条文案，用 message 再拆一次 */
export function credentialErrorKey(
  code: number,
  message = "",
):
  | "credentials.error.32201"
  | "credentials.error.32313"
  | "credentials.error.32314"
  | "credentials.error.secretNotReady"
  | "credentials.error.32300"
  | "credentials.error.32312"
  | "credentials.error.fallback" {
  if (
    code === 32314 &&
    /尚未生成|app_secret|secret/i.test(message)
  ) {
    return "credentials.error.secretNotReady";
  }
  switch (code) {
    case 32201:
      return "credentials.error.32201";
    case 32313:
      return "credentials.error.32313";
    case 32314:
      return "credentials.error.32314";
    case 32300:
      return "credentials.error.32300";
    case 32312:
      return "credentials.error.32312";
    default:
      return "credentials.error.fallback";
  }
}

export function credentialErrorText(t: TFunction, err: unknown): string {
  if (err instanceof ApiError) {
    const key = credentialErrorKey(err.code, err.message);
    if (key !== "credentials.error.fallback") return t(key);
    const message = err.message.trim();
    if (message && !message.startsWith("Request failed")) return message;
    return t(key);
  }
  return t("credentials.error.fallback");
}
